import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { MiscApi } from '@shared/api/rest';
import { ApprovePasswordRequest } from '@shared/api/rest/misc';
import { RequestStrategyEnum } from '@shared/api/rest/models';
import { useNotificationStore } from './notificationStore';
import { Constants } from '@shared/widgets';

interface ApprovePasswordType {
  loading: boolean;
  error: string | null;
  success: boolean | null;
  approvePassword: (request: ApprovePasswordRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApprovePasswordStore = create<ApprovePasswordType>((set) => ({
  loading: false,
  error: null,
  success: null,

  approvePassword: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, error: null, success: null });
      await MiscApi.approvePassword(request, signal);
      set({ loading: false, success: true });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
      useNotificationStore.getState().setError(Constants.PASSWORD_ERROR_MESSAGE);
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: null }),
}));
